import z from 'zod';

import { commonSchemas } from '@project/schemas';

export const UploadProofOfPaymentSchema = z.object({
  referenceNumber: z.string(),
  userBank: z.string(),
  proofOfPayment: commonSchemas.file,
  amountToPayCurrency: z.string(),
  amountToPay: z.number(),
  paymentMethod: z.enum(['debit_credit', 'manual_payment']).optional(),
});
